import CenterActionTypes from './center.types';

/** ***************** ADD CENTER DETAILS START *********************** */
export const addCenterDetailsStart = (addData: any) => ({
	type: CenterActionTypes.ADD_CENTER_DETAILS_START,
	payload: addData,
});

export const addCenterDetailsSuccess = (successData: any) => ({
	type: CenterActionTypes.ADD_CENTER_DETAILS_SUCCESS,
	payload: successData,
});

export const addCenterDetailsFailure = (failureData: any) => ({
	type: CenterActionTypes.ADD_CENTER_DETAILS_FAILURE,
	payload: failureData,
});

export const addCenterDetailsResponseResetStart = () => ({
	type: CenterActionTypes.ADD_CENTER_DETAILS_RESPONSE_RESET,
});

export const addCenterDetailsResponseChanged = () => ({
	type: CenterActionTypes.ADD_CENTER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD CENTER DETAILS END *********************** */

/** ***************** UPDATE CENTER DETAILS START *********************** */
export const updateCenterDetailsStart = (updateData: any) => ({
	type: CenterActionTypes.UPDATE_CENTER_DETAILS_START,
	payload: updateData,
});

export const updateCenterDetailsSuccess = (successData: any) => ({
	type: CenterActionTypes.UPDATE_CENTER_DETAILS_SUCCESS,
	payload: successData,
});

export const updateCenterDetailsFailure = (failureData: any) => ({
	type: CenterActionTypes.UPDATE_CENTER_DETAILS_FAILURE,
	payload: failureData,
});

export const updateCenterDetailsResponseResetStart = () => ({
	type: CenterActionTypes.UPDATE_CENTER_DETAILS_RESPONSE_RESET,
});

export const updateCenterDetailsResponseChanged = () => ({
	type: CenterActionTypes.UPDATE_CENTER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE CENTER DETAILS END *********************** */

/** ***************** GET CENTER LIST START *********************** */
export const getCenterListStart = (getData: any) => ({
	type: CenterActionTypes.GET_CENTER_LIST_START,
	payload: getData,
});

export const getCenterListSuccess = (successData: any) => ({
	type: CenterActionTypes.GET_CENTER_LIST_SUCCESS,
	payload: successData,
});

export const getCenterListFailure = (failureData: any) => ({
	type: CenterActionTypes.GET_CENTER_LIST_FAILURE,
	payload: failureData,
});

export const getCenterListResponseResetStart = () => ({
	type: CenterActionTypes.GET_CENTER_LIST_RESPONSE_RESET,
});

export const getCenterListResponseChanged = () => ({
	type: CenterActionTypes.GET_CENTER_LIST_RESPONSE_CHANGED,
});

/** ***************** GET CENTER LIST END *********************** */

/** ***************** FETCH CENTER DETAILS START *********************** */
export const fetchCenterDetailsStart = (fetchData: any) => ({
	type: CenterActionTypes.FETCH_CENTER_DETAILS_START,
	payload: fetchData,
});

export const fetchCenterDetailsSuccess = (successData: any) => ({
	type: CenterActionTypes.FETCH_CENTER_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchCenterDetailsFailure = (failureData: any) => ({
	type: CenterActionTypes.FETCH_CENTER_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchCenterDetailsResponseResetStart = () => ({
	type: CenterActionTypes.FETCH_CENTER_DETAILS_RESPONSE_RESET,
});

export const fetchCenterDetailsResponseChanged = () => ({
	type: CenterActionTypes.FETCH_CENTER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH CENTER DETAILS END *********************** */

/** ***************** DELETE CENTER DETAILS START *********************** */
export const deleteCenterDetailsStart = (deleteData: any) => ({
	type: CenterActionTypes.DELETE_CENTER_DETAILS_START,
	payload: deleteData,
});

export const deleteCenterDetailsSuccess = (successData: any) => ({
	type: CenterActionTypes.DELETE_CENTER_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteCenterDetailsFailure = (failureData: any) => ({
	type: CenterActionTypes.DELETE_CENTER_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteCenterDetailsResponseResetStart = () => ({
	type: CenterActionTypes.DELETE_CENTER_DETAILS_RESPONSE_RESET,
});

export const deleteCenterDetailsResponseChanged = () => ({
	type: CenterActionTypes.DELETE_CENTER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE CENTER DETAILS END *********************** */
